export default __webpack_public_path__ + "images/Phon_call.jpg";